let vconsole: any = null;
const VConsole = async (): Promise<any> => {
	if (vconsole) {
		return vconsole;
	}
	vconsole = await import(/* webpackChunkName: "vconsole" */ 'vconsole');
	return vconsole;
};
export default VConsole;
